import { isExpired, useJwt } from "react-jwt"
import baseService from "../services/BaseService"
import authService from "./authService";

const AtividadeService = {
    getAll: async () => {            
      const customConfig = {            
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`, 
          },
      };  
      
      const response = await baseService. get(`/Atividade/ObterTodos?pageNumber=1&pageSize=1000`, customConfig);                                
      return response;
    },
    getByID: async (id) => {          
      const customConfig = {            
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`, 
          },
      };  
      
      var newId = decodeURIComponent(id);      
      const response = await baseService.get(`/Atividade/ObterPorId?id=${newId}`, customConfig);                    
      return response;
    },
    getByName: async (name) => {              
      const customConfig = {            
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`, 
          },
      };  

      const response = await baseService.get(`/Atividade/ObterPorDescricao?descricao=${name}`, customConfig);                    
      return response;       
    },
    putAtividade: async (obj, id) => {         
      const customConfig = {            
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`, 
          },
      };          

      const response = await baseService.put(`/Atividade/Atualizar/${id}`, obj, customConfig);                    
      return response;             
    },
    postAtividade: async (obj) => {            
      const customConfig = {            
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`, 
          },
      };  
      
      const response = await baseService.post(`/Atividade/Cadastrar`, obj, customConfig);                    
      return response;                 
        
        
    },
    putInativeAtividade: async (id) => {                  
      const customConfig = {            
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`, 
          },
      };          

      const response = await baseService.put(`/Atividade/Inativar/${id}`, customConfig);                        
      return response;                      
    },
    deleteAtividade: async(id) => {
      const customConfig = {            
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`, 
        },
      };          

      const response = await baseService.delete(`/Atividade/ExcluirHorario/${id}`, customConfig);                        
      return response;        
    }
  };
  
  export default AtividadeService;